import { ReactNode } from 'react';
import ContainerWrapper from './style';

export interface ContainerProps {
  children?: ReactNode;
  className?: string;
  fullWidth?: boolean;
  noGutter?: boolean;
  mobileGutter?: boolean;
  width?: string | number;
}

const Container = ({
  children,
  className,
  fullWidth,
  noGutter,
  mobileGutter,
  width,
}: ContainerProps) => {
  const addAllClasses = ['container'];
  if (className) addAllClasses.push(className);

  return (
    <ContainerWrapper
      className={addAllClasses.join(' ')}
      fullWidth={fullWidth}
      noGutter={noGutter}
      width={width}
      mobileGutter={mobileGutter}
    >
      {children}
    </ContainerWrapper>
  );
};

export default Container;
